import * as yup from 'yup';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import type { CadastreOfRealEstateFilterForm } from './context.types';

export interface FormInstanceProps {
	defaultValues: CadastreOfRealEstateFilterForm;
}

export function FormInstance({
	defaultValues,
}: FormInstanceProps): FormDefinition<CadastreOfRealEstateFilterForm> {
	const formSchema = yup
		.object({
			text: yup.string().optional(),
		})
		.required();

	const formMethods = useGovForm<CadastreOfRealEstateFilterForm>({
		formSchema,
		defaultValues,
	});
	return getFormDefinition({ formMethods, formSchema });
}
